package com.arena_web.pages

import androidx.compose.runtime.Composable
import com.arena_web.ui.sections.sports.SportsIndexContent
import com.varabyte.kobweb.core.Page

@Page("/sports")
@Composable
fun SportsPage() = SportsIndexContent()
